import React from 'react';
import Warning from './Warning';

interface Props {
  funds?: string[];
}

const PastPerformanceMissingFunds = ({ funds }: Props) => {
  const areFundNamesProvided = funds && funds.length > 0;
  const text = `Performance data
    ${
      areFundNamesProvided
        ? ` of Fund(s): "${
            funds && funds.join(', ')
          }" is not available because it's no `
        : ' is not available because one or more funds are no '
    }
    longer supported by our data provider.`;

  return <Warning text={text} />;
};

export default PastPerformanceMissingFunds;
